import { env } from '@shared/config/env';

/**
 * Thin logging facade. In development it proxies to the console; in production
 * it stays quiet by default and provides a single seam to forward errors to an
 * observability backend (Sentry, Datadog, etc.) later without touching call
 * sites.
 */
type LogArgs = readonly unknown[];

function shouldLog(): boolean {
  return env.isDevelopment;
}

export const logger = {
  debug: (...args: LogArgs): void => {
    if (shouldLog()) console.debug('[HEXAUNITY]', ...args);
  },
  info: (...args: LogArgs): void => {
    if (shouldLog()) console.info('[HEXAUNITY]', ...args);
  },
  warn: (...args: LogArgs): void => {
    if (shouldLog()) console.warn('[HEXAUNITY]', ...args);
  },
  error: (...args: LogArgs): void => {
    // Errors are always surfaced; wire up remote reporting here.
    console.error('[HEXAUNITY]', ...args);
  },
} as const;
